<template>
<div class="chapter">
<div class="inner_page">
<h3 class="sigilnotintoc1" id="pgepubid00005">ILLUSTRATIONS</h3>
<p class="calibre1"><br class="calibre2"/></p>
<div class="centered">
<table border="0" cellpadding="2" cellspacing="0" class="calibre7" summary="List of Illustrations" width="75%">
<tbody class="calibre8">
<tr class="calibre9">
<td class="tdlsc"><a class="calibre4" href="#/Text/Section0004.htm#imagepxliv">Interior of a Submarine</a></td>
<td class="tdr1">xliv</td>
</tr>
<tr class="calibre9">
<td class="tdlsc"><a class="calibre4" href="#/Text/Section0007.htm#imagep036">A Torpedoed Schooner</a></td>
<td class="tdr1">36</td>
</tr>
<tr class="calibre9">
<td class="tdlsc"><a class="calibre4" href="#/Text/Section0008.htm#imagep040">German Submarines U 13, U 5, U 11, U 3, and U 16 in Kiel Harbor</a></td>
<td class="tdr1">40</td>
</tr>
<tr class="calibre9">
<td class="tdl"><a class="calibre4" href="#/Text/Section0010.htm#imagep078"><span class="sc1">Von Forstner's Submarine (U 28) in Action in the North Sea: A Series of Photographs taken from the Deck of one of her Victims</span></a><br class="calibre2"/>
<span class="c">From the London <i class="calibre10">Graphic</i>, March 27, 1915</span></td>
<td class="tdr1">78</td>
</tr>
<tr class="calibre9">
<td class="tdlsc"><a class="calibre4" href="#/Text/Section0011.htm#imagep098">Lifeboat leaving the Sinking P. and O. Liner Arabia</a></td>
<td class="tdr1">98</td>
</tr>
<tr class="calibre9">
<td class="tdlsc"><a class="calibre4" href="#/Text/Section0012.htm#imagep126">British Hospital Ship Gloucester Castle, showing Red Cross on Bow, sunk in the English Channel by a German Submarine</a></td>
<td class="tdr1">126</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?9e022ce2